import React, { useState } from "react";

//Assets 
import LogoCol from "../img/logo_colsubsidio.png";
import MainBk from "../img/viviendas_existentes/5.Fondo-ProyectosExistentes.jpg";
import ImageBarichara from "../img/viviendas_existentes/5.Capsula-PE-Barichara.png";
import ImageMonpos from "../img/viviendas_existentes/5.Capsula-PE-Mompos.png";
import ImageOcana2 from "../img/viviendas_existentes/5.Capsula-PE-Ocanha2.png";
import ImageAmbalema from "../img/viviendas_existentes/5.Capsula-PE-Ambalema.png";
import ImageOcana1 from "../img/viviendas_existentes/5.Capsula-PE-Ocanha1.png";
import ImageJardin from "../img/viviendas_existentes/5.Capsula-PE-jardin.png";

//Data Display
import TopLeftTitle from "../data_display/TopLeftTitle";
import ButtonLeftTitle from "../data_display/BottomLeftTitle";
import MiniaturePreview from "../data_display/MiniaturePreview";
import PointDefault from "../data_display/PointLocation";

//Inputs
import HomeButton from "../inputs/HomeButton";

//Navigation
import MenuMiniatures from "../navigation/MenuMiniatures";

const listMiniatures = [{
    id: "1",
    title:"552",
    subtitle:"Unidades",
    image: ImageBarichara,
    x: "32%",
    y: "36%"
}, {
    id: "2",
    title:"768",
    subtitle:"Unidades",
    image: ImageMonpos,
    x: "22%",
    y: "40%"
}, {
    id: "3",
    title:"480",
    subtitle:"Unidades",
    image: ImageOcana2,
    x: "43.5%",
    y: "36%"
}, {
    id: "4",
    title:"744",
    subtitle:"Unidades",
    image: ImageAmbalema,
    x: "28%",
    y: "39%"
}, {
    id: "5",
    title:"400",
    subtitle:"Unidades",
    image: ImageOcana1,
    x: "39%",
    y: "36%"
}, {
    id: "6",
    title:"480",
    subtitle:"Unidades",
    image: ImageJardin,
    x: "58%",
    y: "34%"
}];

export default function ViviendasExistentesPage () {
    const [currentItem, SetCurrentItem] = useState(0);

    function onClickMiniature(tmpIndex)
    {
        SetCurrentItem(tmpIndex);
    }

    return (
        <div style={{width:"100%", height:"100%", backgroundImage:"url("+MainBk+")", backgroundSize:"contain"}}>
            <div style={{position:"absolute", right:"80px", top:"20px", width:"200px"}}>
                <img src={LogoCol} style={{width:"100%"}}/>
            </div>
            <TopLeftTitle title={"PROYECTOS EXISTENTES"} subtitle={""} />
            <ButtonLeftTitle title={"3.424"} subtitle={"Unidades"} />
            <HomeButton/>
            <MiniaturePreview item={listMiniatures[currentItem]}/>
            <MenuMiniatures items={listMiniatures} selected={currentItem} onClick={onClickMiniature}/>
            {
                listMiniatures.map((item, index)=>{
                    return (<PointDefault key={item.id} id={item.id} 
                        x={item.x} y={item.y} index={index}
                        onClick={onClickMiniature}
                        selected={index === currentItem ? true:false}
                        />
                    )
                })
            }
        </div>
    );
}